import styled, { css } from 'styled-components';

export const DroppableContainer = styled.div`
  width: 95%;
  padding-bottom: 10px;
  padding-top: 1px;
  margin-top: 10px;
`;

export const DraggableItem = styled.div`
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #C5C5D4;

  margin: 10px 0px 0 0px;
  user-select: none;
  background: #fff;

  ${props => props.isDragging && css`
    border: 1px solid #00000055;
    -webkit-box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
    -moz-box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
    box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
  `}
`;

export const DraggableHandle = styled.div`
  display: flex;
  justify-content: center;
`;
